import { useEffect, useState } from 'react';
import { getKconfData } from '@/common/kconf';
import { currentCountry } from '@/common/const';
import { useFirstScreenAB } from '@/hooks/abTest/firstScreen/useFirstScreenAb';

export function useABHandler() {
    const state = useFirstScreenAB();
    return { detailABValueMap: state };
}

let thresholdValueCache = null;
export function useInstallmentFirstThresholdValue() {
    const [thresholdValue, setThresholdValue] = useState(null);

    const getDate = async () => {
        try {
            const kconfRes = await getKconfData('overseaServer.ecommerceContent.productInstallmentHighValueLimit');
            console.log('kconfRes', kconfRes[currentCountry]);
            const _threhold = kconfRes[currentCountry] || Number.MAX_SAFE_INTEGER;

            thresholdValueCache = _threhold;
            setThresholdValue(_threhold);
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        if (thresholdValueCache !== null) {
            setThresholdValue(thresholdValueCache);
        } else getDate();
    }, []);

    return {
        thresholdValue,
    };
}
